import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './badge.module.scss';

export type BadgeVariant = 'error' | 'warning' | 'success' | 'info' | 'neutral';

type Props = {
  children: ReactNode;
  variant?: BadgeVariant;
  /** Optional leading icon (e.g. a react-icons element) rendered before the label. */
  icon?: ReactNode;
  className?: string;
  'data-testid'?: string;
};

/**
 * Generic status pill: a coloured rounded label with an optional leading icon.
 * Use for short inline states (e.g. an "Error" result cell). For the richer
 * deployment lifecycle states, use `DeploymentStatusBadge` instead.
 */
export function Badge( { children, variant = 'neutral', icon, className, 'data-testid': dataTestId }: Props ) {
  return (
    <span
      className={ clsx( styles.badge, styles[ `badge--${ variant }` ], className ) }
      data-testid={ dataTestId }
    >
      { icon && <span className={ styles.icon } aria-hidden="true">{ icon }</span> }
      <span>{ children }</span>
    </span>
  );
}
